<template>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    
    <el-form-item label="设备ID" prop="id">
      <el-input v-model="ruleForm.id"></el-input>
    </el-form-item>
    <el-form-item label="是否在线" >
      <el-button @click="checkOnline()">点击检查</el-button>
    </el-form-item>
    
    <el-form-item>
      <el-button type="danger" @click="submitForm('ruleForm')">解除授权</el-button>
    </el-form-item>
    
    </el-form>
    
    </template>
    
      <script>
        export default {
          data() {
            return {
              params:[],
              ruleForm: {
                id: ''
              },
              
              rules: {
                id: [
                  { required: true, message: '请输入设备ID', trigger: 'blur' }
                ]
              }
            };
          },
          mounted() {
            console.log(this.$route.query.id)
            this.ruleForm.id=this.$route.query.id
         },
          methods: {
          
           
            checkOnline(){
              this.request.get("/deviceOnlineState",{params:{"ID":this.ruleForm.id}}).then(res => {
                if(res.code=='0'){
                  this.$message({message:res.data,type: 'success'});         
                }else{
                  this.$message.error(res.msg);
                }
                                                               
                           }).catch(error => { console.log(error)})
            },

            
    deleteById() {
		this.$confirm('确认解除ID为'+this.ruleForm.id+'的设备授权？').then(_ => { this.delete(this.ruleForm.id) }).catch(_ => {});
	  },
	  delete(i) {
		this.request.get('/deleteDeviceByDeviceId', { params: { "ID": i } }).then(response => {
		  if (response.code == "0") {
			this.$message({ message: '解除授权成功', type: 'success' });
			this.fetchData();
		  } else {
			this.$message.error('解除授权失败');
		  }
		}).catch(error => { console.log(error) });
	  },
            
      submitForm(formName) {
         
         this.$refs[formName].validate((valid) => {
           if (valid) {
             
            this.deleteById(); 
                 
               
              
           } else {
             console.log('error submit!!');
             return false;
           }
         });
       }
      }
    
    }
        
      </script>